module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/multiple-properties-email-d7203761cbcddcbae67331c59e7c292c.svg";